(function () {
  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const titleCase = (value) => {
    return String(value || '')
      .split(' ')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');
  };

  const formatDashTitleHtml = (rawValue) => {
    const raw = String(rawValue || '').trim();
    if (!raw) return '';

    const normalized = raw.replace(/\s*–\s*/g, ' - ').replace(/\s*—\s*/g, ' - ');
    const parts = normalized.split(' - ');
    const left = String(parts.shift() || '').trim();
    const right = String(parts.join(' - ') || '').trim();
    const leftHtml = `<strong>${escapeHtml(left)}</strong>`;
    if (!right) return leftHtml;
    return `${leftHtml} - ${escapeHtml(right)}`;
  };

  const getRootPath = () => {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  const initUpsellCards = (root = document) => {
    root.querySelectorAll('.product-upsell__item[data-upsell-card="true"]').forEach((item) => {
      if (item.dataset.upsellCardInit === '1') return;
      item.dataset.upsellCardInit = '1';

      const form = item.querySelector('.product-upsell__form');
      const hiddenInput = form ? form.querySelector('input[name="id"]') : null;
      const swatchContainer = item.querySelector('.product-upsell__swatches');
      const colorNameEl = item.querySelector('.product-upsell__color-name');

      if (colorNameEl && !colorNameEl.textContent.trim()) {
        colorNameEl.textContent = 'Bitte Farbe wählen';
      }

      if (hiddenInput && (!hiddenInput.value || hiddenInput.value === '')) {
        const defaultVariantId = item.dataset.defaultVariantId || '';
        const swatches = swatchContainer ? Array.from(swatchContainer.querySelectorAll('.product-upsell__swatch-btn')) : [];
        if (swatches.length) {
          const preferred = defaultVariantId ? swatches.find((b) => String(b.dataset.variantId) === String(defaultVariantId)) : null;
          const firstAvailable = swatches.find((b) => b.dataset.variantAvailable !== 'false');
          const initial = preferred || firstAvailable || swatches[0];
          if (initial) {
            initial.classList.add('active');
            hiddenInput.value = initial.dataset.variantId || '';
            if (colorNameEl) {
              const label = initial.getAttribute('aria-label') || initial.dataset.variantTitle || '';
              colorNameEl.innerHTML = label ? formatDashTitleHtml(label) : '';
            }
            updateSubmitBtnState(item, initial.dataset.variantAvailable !== 'false');
          }
        }
      }
    });
  };

  const updateSubmitBtnState = (item, isAvailable) => {
    const form = item.querySelector('.product-upsell__form');
    const submitBtn = form ? form.querySelector('button') : null;
    if (!submitBtn) return;
    submitBtn.disabled = !isAvailable;
    submitBtn.classList.toggle('is-sold-out', !isAvailable);
  };

  const revealSwatches = (btn) => {
    const swatchWrap = btn.closest('.product-upsell__swatches');
    if (!swatchWrap) return;
    swatchWrap.querySelectorAll('.product-upsell__swatch-btn.is-hidden').forEach((b) => b.classList.remove('is-hidden'));
    btn.style.display = 'none';
  };

  const setActiveSwatch = (btn, { showTooltip = true } = {}) => {
    const item = btn.closest('.product-upsell__item[data-upsell-card="true"]');
    if (!item) return;
    const form = item.querySelector('.product-upsell__form');
    const hiddenInput = form ? form.querySelector('input[name="id"]') : null;
    const colorNameEl = item.querySelector('.product-upsell__color-name');
    const inlineError = item.querySelector('.product-upsell__inline-error');
    const submitBtn = form ? form.querySelector('button') : null;
    const validationMsg = submitBtn ? submitBtn.querySelector('.product-upsell__validation-msg') : null;

    item.querySelectorAll('.product-upsell__swatch-btn').forEach((b) => b.classList.remove('active', 'tooltip-visible'));
    btn.classList.add('active');

    if (hiddenInput) hiddenInput.value = btn.dataset.variantId || '';

    if (colorNameEl) {
      const label = btn.getAttribute('aria-label') || btn.dataset.variantTitle || '';
      colorNameEl.innerHTML = label ? formatDashTitleHtml(label) : '';
    }

    if (validationMsg) validationMsg.classList.remove('active');
    if (inlineError) inlineError.classList.remove('active');

    updateSubmitBtnState(item, btn.dataset.variantAvailable !== 'false');

    if (showTooltip) {
      btn.classList.add('tooltip-visible');
      if (btn.tooltipTimeout) clearTimeout(btn.tooltipTimeout);
      btn.tooltipTimeout = setTimeout(() => {
        btn.classList.remove('tooltip-visible');
        btn.tooltipTimeout = null;
      }, 2000);
    }
  };

  const addToCart = async ({ form, submitBtn }) => {
    const hiddenInput = form.querySelector('input[name="id"]');
    const item = form.closest('.product-upsell__item[data-upsell-card="true"]');
    const inlineError = item ? item.querySelector('.product-upsell__inline-error') : null;
    const validationMsg = submitBtn.querySelector('.product-upsell__validation-msg');

    if (submitBtn.disabled) return;

    const activeSwatch = item ? item.querySelector('.product-upsell__swatch-btn.active') : null;
    if (activeSwatch && activeSwatch.dataset.variantAvailable === 'false') return;

    if (!hiddenInput || !hiddenInput.value) {
      if (validationMsg) {
        validationMsg.classList.add('active');
        setTimeout(() => validationMsg.classList.remove('active'), 3000);
      }
      if (inlineError) inlineError.classList.add('active');
      return;
    }

    if (submitBtn.classList.contains('loading')) return;
    submitBtn.classList.add('loading');

    const spinner = submitBtn.querySelector('.loading__spinner');
    const iconSvg = submitBtn.querySelector('.product-upsell__icon-svg');
    if (spinner) spinner.classList.remove('hidden');
    if (iconSvg) iconSvg.classList.add('hidden');

    const formData = new FormData(form);

    try {
      const response = await fetch(getRootPath() + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
      });
      const data = await response.json();

      if (data && data.status) {
        console.error(data.description);
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble&t=${Date.now()}`)
          .then((res) => res.json())
          .then((sections) => {
            if (cartDrawer.renderContents) {
              cartDrawer.renderContents({ sections, item_count: 1 });
            }
            if (cartDrawer.open) cartDrawer.open(submitBtn);
          });
      } else if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-card', cartData: data });
      } else {
        window.location.href = '/cart';
      }
    } catch (e) {
      console.error(e);
    } finally {
      submitBtn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      if (iconSvg) iconSvg.classList.remove('hidden');
    }
  };

  const handleClick = (event) => {
    const showMoreBtn = event.target.closest('.product-upsell__show-more-btn');
    if (showMoreBtn) {
      event.preventDefault();
      event.stopPropagation();
      revealSwatches(showMoreBtn);
      return;
    }

    const swatchBtn = event.target.closest('.product-upsell__swatch-btn');
    if (swatchBtn) {
      event.preventDefault();
      event.stopPropagation();
      setActiveSwatch(swatchBtn, { showTooltip: true });
    }
  };

  const handleSubmit = (event) => {
    const form = event.target.closest('.product-upsell__form');
    if (!form) return;
    const item = form.closest('.product-upsell__item[data-upsell-card="true"]');
    if (!item) return;
    event.preventDefault();
    event.stopPropagation();

    const submitBtn = form.querySelector('button');
    if (!submitBtn) return;
    addToCart({ form, submitBtn });
  };

  const boot = () => {
    initUpsellCards(document);
    document.addEventListener('click', handleClick);
    document.addEventListener('submit', handleSubmit, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initUpsellCards(event.target || document);
  });
})();
